module.exports = __webpack_public_path__ + "audio-7e0eb257a822.m4a";